jQuery( document ).ready( function ( $ ) {
	function JTFSELECTOR() {
		console.log( '[JTF Gut Block - JS] jtf/jtf-selector v2.0' )
		this.init()
	}

	/**
	 * Function to move the selector to a new slide (requires parent and inner for calcs)
	 */
	JTFSELECTOR.prototype.navigateCarousel = function () {
		const inner = $( document ).find( '.jtf__selectorblock--inner' )
		const position = $( document ).find( '.jtf__selectorblock--container' ).attr( 'data-position' )
		inner.css( { 'transform': 'translateX(-' + (inner.width() * position) + 'px)' } )
	}

	/**
	 * Sets which dot is currently active, resets the state on the others
	 *
	 * @param active
	 */
	JTFSELECTOR.prototype.setActiveDot = function ( active ) {
		$( document ).find( '.jtf__selectorblock--dot-active' ).removeClass( 'jtf__selectorblock--dot-active' )
		$( document ).find( '.jtf__selectorblock--dot' ).each( function () {
			if ( parseInt( $( this ).attr( 'data-target' ) ) == parseInt( active ) ) {
				//console.log( parseInt( $( this ).attr( 'data-target' ) ), parseInt( active ) )
				$( this ).addClass( 'jtf__selectorblock--dot-active' )
			}
		} )
	}

	/**
	 * Initial Carousel load
	 * Generates the buttons and maps click functions to them
	 *
	 * @param thisInstance
	 */
	JTFSELECTOR.prototype.loadCarousel = function ( thisInstance ) {
		const self = this
		$( document ).on( 'click', '.jtf__selectorblock--prev', function () {
			const parent = $( document ).find( '.jtf__selectorblock--container' )
			let position = parent.attr( 'data-position' )
			parent.attr( 'data-max', 'false' )
			if ( position > 0 ) {
				parent.attr( 'data-position', parseInt( position ) - 1 )
				self.setActiveDot( parseInt( position ) - 1, parent )
				self.navigateCarousel()
			}

			if ( position == '1' ) {
				$( this ).addClass( 'jtf__selectorblock--navigation-inactive' )
			}
		} )

		$( document ).on( 'click', '.jtf__selectorblock--next', function () {
			const parent = $( document ).find( '.jtf__selectorblock--container' )
			let position = parent.attr( 'data-position' )
			let inner = $( document ).find( '.jtf__selectorblock--inner' ).attr( 'data-children' )
			let prev = $( document ).find( '.jtf__selectorblock--prev' )

			prev.removeClass( 'jtf__selectorblock--navigation-inactive' )

			if ( (parseInt( position ) + 1) < parseInt( inner ) ) {
				parent.attr( 'data-position', parseInt( position ) + 1 )
				self.setActiveDot( parseInt( position ) + 1, parent )
				self.navigateCarousel()
			} else {
				prev.addClass( 'jtf__selectorblock--navigation-inactive' )
				parent.attr( 'data-position', 0 )
				self.setActiveDot( 0, parent )
				self.navigateCarousel()
			}
		} )

		$( document ).on( 'click', '.jtf__selectorblock--dot', function () {
			let position = $( this ).attr( 'data-target' )
			let prev = $( document ).find( '.jtf__selectorblock--prev' )

			$( document ).find( '.jtf__selectorblock--container' ).attr( 'data-position', parseInt( position ) )
			self.setActiveDot( parseInt( position ), thisInstance )

			//Turn off previous button if we're on the first panel
			if ( parseInt( position ) == 0 ) {
				prev.addClass( 'jtf__selectorblock--navigation-inactive' )
			} else {
				prev.removeClass( 'jtf__selectorblock--navigation-inactive' )
			}
			self.navigateCarousel()
		} )
	}

	/**
	 * Generate the Arrows and Dot navigation
	 *
	 * Slide counter should be equal to a rounded up number of how many carousel items we have divided by 3 (we have 3 items per panel)
	 * IE 3 items is 1 panel, 5 items is 2 panels, 7 items is 3 panels ETC
	 * @param slideCount (int)
	 */
	JTFSELECTOR.prototype.generateNavigation = function ( slideCount ) {
		let active = ''
		let parent = $( document ).find( '.jtf__selectorblock--dots' )
		let grandParent = $( document ).find( '.jtf__selectorblock--nav' )
		let currentPosition = $( document ).find( '.jtf__selectorblock--container' ).attr( 'data-position' )
		let styleAttr = $( document ).find( '.jtf__selectorblock--container' ).attr( 'style' )

		// Wipe the grandparent before we insert the navigation arrows again,
		// otherwise they get appended every time this refreshes and we get multiple
		grandParent.html( parent )
		// Append the 2 navigation arrows either side of the dots section
		if ( currentPosition == '0' ) {
			parent.before( '<a class="jtf__selectorblock--prev jtf__selectorblock--navigation jtf__selectorblock--navigation-inactive" style="' + styleAttr + '" href="javascript:void(0);"><i class="far fa-angle-left"></i></a>' )
		} else {
			parent.before( '<a class="jtf__selectorblock--prev jtf__selectorblock--navigation" style="' + styleAttr + '" href="javascript:void(0);"><i class="far fa-angle-left"></i></a>' )
		}

		parent.after( '<a class="jtf__selectorblock--next jtf__selectorblock--navigation" href="javascript:void(0);" style="' + styleAttr + '"><i class="far fa-angle-right"></i></a>' )
		// Wipe the dots section so we can add the correct amount of new dots into that container
		parent.html( '' )

		for ( let x = 0; x < slideCount; x++ ) {
			if ( x == 0 ) {
				active = 'jtf__selectorblock--dot-active'
			} else {
				active = ''
			}

			parent.append( '<a href="#" class="jtf__selectorblock--dot ' + active + '" data-target="' + x + '" style="' + styleAttr + '"><i class="fas fa-circle"></i></a>' )
		}
	}

	JTFSELECTOR.prototype.removeNavigation = function () {
		let container = $( document ).find( '.jtf__selectorblock--navigation' )
		container.html( '' )
	}

	/**
	 * REBOOT CAROUSEL
	 *
	 * This will reset the navigation items, hide and reveal the correct carousel items and reset the widths of the items
	 *
	 */
	JTFSELECTOR.prototype.reboot = function () {
		const self = this
		var panelItemCount = 3

		if ( $( window ).width() < 600 ) {
			panelItemCount = 1
		}

		const container = $( document ).find( '.jtf__selectorblock--container' )
		const itemWidth = container.width() / panelItemCount
		const inner = $( document ).find( '.jtf__selectorblock--inner' )

		// Reset container position on reboot, this ensures
		// we always return to the first carousel panel
		container.attr( 'data-position', 0 )
		// Wipe the translate offset which puts us back
		// to the first carousel panel
		inner.css( { 'transform': 'translateX(0)' } )

		if ( $( '.wp-admin' ).length > 0 ) {
			// This needs to be in the timeout for wp-admin,
			// otherwise this tries to fire before the options
			// have been reset and then nothing works
			setTimeout( function () {
				let childElCount = Math.ceil( $( document ).find( '.jtf__selectorblock--item' ).length / panelItemCount )
				$( document ).find( '.jtf__selectorblock--inner' ).attr( 'data-children', childElCount )

				if ( childElCount > 1 ) {
					self.generateNavigation( childElCount )
				} else {
					self.removeNavigation()
				}

				$( document ).find( '.jtf__selectorblock--item' ).css( {
					width: itemWidth + 'px',
					display: 'inline-block',
				} )
			}, 300 )
		} else {
			let currentSelection = $( '.jtf__selectorblock--selector-select' ).children( "option:selected" ).val()
			// Needs to only find children that have a matching parent to the current selector
			let childElCount = Math.ceil( $( document ).find( '.jtf__selectorblock--item[data-parent="' + currentSelection + '"]' ).length / panelItemCount )
			inner.attr( 'data-children', childElCount )

			if ( childElCount > 1 ) {
				self.generateNavigation( childElCount )
			} else {
				self.removeNavigation()
			}

			// Don't add the timeout on the front end, cos we're not waiting on anything
			// Also, we can use jQuery here because it's frontend yay
			// We only wanna add inline-block to elements that have a matching parent to the current selector
			$( '.jtf__selectorblock--item' ).each( function () {
				$( this ).css( { width: itemWidth + 'px' } )
				if ( $( this ).attr( 'data-parent' ) == currentSelection ) {
					$( this ).css( { display: 'inline-block' } )
				} else {
					$( this ).css( { display: 'none' } )
				}
			} )
		}
	}

	/**
	 * Default actions happening on device actions
	 */
	JTFSELECTOR.prototype.init = function ( thisInstance ) {
		const self = this
		$( document ).find( '.jtf__selectorblock--container' ).attr( 'data-position', 0 )
		$( document ).on( 'click', '.jtf__selectorblock--selector-button', function ( e ) {
			e.preventDefault()
			self.reboot( thisInstance )
		} )
		self.loadCarousel( thisInstance )
	}
	if ( $( '.wp-admin' ).length > 0 ) {
		new JTFSELECTOR()
	} else {
		// Don't use timeout on front end
		if ( $( '.wp-block-jtf-jtf-selector' ).length > 0 ) {
			// Instantiate a new instance for each block
			// on a page (not that there should be more than 1...)
			$( '.wp-block-jtf-jtf-selector' ).each( function () {
				new JTFSELECTOR( $( this ) )
			} )
		}
	}
} )
